import { initializeApp } from "@firebase/app";
import { getMessaging, getToken, onMessage } from "@firebase/messaging";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: "flutter-verden.firebaseapp.com",
  projectId: "flutter-verden",
  storageBucket: "flutter-verden.appspot.com",
  messagingSenderId: "853984305647",
  appId: "1:853984305647:web:f5c56081477b8bab0e961a",
  measurementId: "G-359D3H4KB2",
};

const isMobileDevice = () => {
  if (typeof window === "undefined") return false;

  const userAgent = navigator.userAgent.toLowerCase();
  const mobileKeywords = [
    "android",
    "iphone",
    "ipad",
    "ipod",
    "blackberry",
    "windows phone",
  ];
  const isMobileUA = mobileKeywords.some((keyword) =>
    userAgent.includes(keyword),
  );

  const isTouchDevice =
    "ontouchstart" in window || navigator.maxTouchPoints > 0;
  const isSmallScreen = window.innerWidth <= 768;

  return isMobileUA || (isTouchDevice && isSmallScreen);
};

const isFirebaseMessagingSupported = () => {
  if (typeof window === "undefined") return false;

  const hasServiceWorker = "serviceWorker" in navigator;
  const hasPushManager = "PushManager" in window;
  const hasNotifications = "Notification" in window;

  return (
    hasServiceWorker && hasPushManager && hasNotifications && !isMobileDevice()
  );
};

import type { Messaging } from "@firebase/messaging";

let messaging: Messaging | null = null;

if (isFirebaseMessagingSupported()) {
  try {
    messaging = getMessaging(initializeApp(firebaseConfig));
  } catch (error) {
    console.warn("Firebase messaging initialization failed:", error);
  }
}

export { getToken, isFirebaseMessagingSupported, messaging, onMessage };
